import { AxiosError } from 'axios';

export const processResponseErrors = (error: unknown) => error instanceof AxiosError && (error.response?.data.errors || [{ code: '', message: error.message || 'Undefined Error' }]);
